import { Routes } from '@angular/router';
import { AgreementsGuard, GUARDS } from 'smartauction-frontend-micro-library';
import { AuthGuard, RoleBasedGuard } from 'remarketing-angular-library';
import { OfferListPaths } from './shared/enum/offer-list.enum';

export const offerListRoutes: Routes = [
  {
    path: OfferListPaths.OFFER_LIST,
    canActivate: [AuthGuard, RoleBasedGuard],
    data: { roles: ['View_Only'] },
    children: [
      {
        path: OfferListPaths.SHARED_LIST,
        loadComponent: () => import('./components/shared-lists-shell/shared-lists-shell.component').then(c => c.SharedListsShellComponent),
        canActivate: [AgreementsGuard],
        data: {
          guards: [
            GUARDS.TermsOfUseGuard,
            GUARDS.PrivacyPolicyGuard
          ]
        }
      },
      {
        path: OfferListPaths.IN_SERVICE_LIST,
        loadComponent: () => import('./components/shared-lists-shell/shared-lists-shell.component').then(c => c.SharedListsShellComponent),
        canActivate: [AgreementsGuard],
        data: {
          guards: [
            GUARDS.TermsOfUseGuard,
            GUARDS.PrivacyPolicyGuard
          ]
        }
      },
      {
        path: OfferListPaths.CUSTOM_OFFERS,
        loadComponent: () => import('./components/shared-lists-shell/shared-lists-shell.component').then(c => c.SharedListsShellComponent),
        canActivate: [AgreementsGuard],
        data: {
          guards: [
            GUARDS.TermsOfUseGuard,
            GUARDS.PrivacyPolicyGuard
          ]
        }
      },
      {
        path: OfferListPaths.OFFER_LIST_UUID,
        loadComponent: () => import('./components/offer-list-detail-shell/offer-list-detail-shell.component').then(c => c.OfferListDetailShellComponent),
        canActivate: [AgreementsGuard],
        data: {
          guards: [
            GUARDS.TermsOfUseGuard,
            GUARDS.PrivacyPolicyGuard
          ]
        }
      }
    ]
  },
];
